import { render, staticRenderFns } from "./MinimalLayout.vue?vue&type=template&id=571fd42e"
import script from "./MinimalLayout.vue?vue&type=script&lang=js"
export * from "./MinimalLayout.vue?vue&type=script&lang=js"
import style0 from "./MinimalLayout.vue?vue&type=style&index=0&id=571fd42e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports